<template>
    <div id="good-list">
        <div class="good-list-tit">
            <div class="tit-left">{{ $t('精选商品') }}</div>
            <div class="tit-right">
                <div class="flex align-center tit-right-project" :class="order == 'comprehensive' ? 'tit-right-project-active' : ''"
                    @click="onSort('comprehensive')">
                    <span>{{ $t('综合') }}</span>
                </div>
                <div class="flex align-center tit-right-project" :class="order == 'price' ? 'tit-right-project-active' : ''"
                    @click="onSort('price')">
                    <span>{{ $t('价格') }}</span>
                    <div v-if="order == 'price'">
                        <img src="../../../../static/images/icon/icon13.png" alt="" v-if="orderway == ''">
                        <img src="../../../../static/images/icon/icon33.png" alt="" v-if="orderway == 'desc'">
                        <img src="../../../../static/images/icon/icon32.png" alt="" v-if="orderway == 'asc'">
                    </div>
                    <img src="../../../../static/images/icon/icon13.png" alt="" v-else>
                </div>
                <div class="flex align-center tit-right-project" :class="order == 'time' ? 'tit-right-project-active' : ''"
                    @click="onSort('time')">
                    <span>{{ $t('时间') }}</span>
                    <div v-if="order == 'time'">
                        <img src="../../../../static/images/icon/icon13.png" alt="" v-if="orderway == ''">
                        <img src="../../../../static/images/icon/icon33.png" alt="" v-if="orderway == 'desc'">
                        <img src="../../../../static/images/icon/icon32.png" alt="" v-if="orderway == 'asc'">
                    </div>
                    <img src="../../../../static/images/icon/icon13.png" alt="" v-else>
                </div>
                <el-dropdown popper-class="featured-category-dropdown" @command="handleCommand">
                    <el-button plain size="mini" class="category-filter-button">
                        {{ $t('全部类别') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in category_list" :key="index" :command="item.id">
                            {{ item.name }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="list">
            <div class="list-box" v-for="(item, index) in goodFreshList" :key="index" @click="gotoDetail(item)">
                <div class="img-container">
                    <img :src="item.cover" alt="" class="box-img">
                </div>
                <div class="box-bottom">
                    <div class="box-bottom-tit line2">{{ item.name }}</div>
                    <div class="box-bottom-box">
                        <div class="box-bottom-box-l">
                            ￥<span class="text-20">{{ item.price }}</span>
                        </div>
                        <div class="box-bottom-box-r">
                            <div class="box-bottom-box-rr">
                                <div class="box-bottom-box-rrl" style="border-right: 1px solid #000000;"
                                    @click.stop="onCollect(item.id, index)">
                                    <img src="../../../../static/images/icon/icon35.png" alt="" v-if="item.is_collect">
                                    <img src="../../../../static/images/icon/icon18.png" alt="" v-else>
                                </div>
                                <div class="box-bottom-box-rrl">
                                    <img src="../../../../static/images/icon/icon07.png" alt="">
                                </div>
                                <div class="box-bottom-box-rrr">{{ $t('购买') }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="list-box-tag" v-if="item.product_type">{{ $t('虚拟商品') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { commodityList, categoryListings, commodityCollect } from '@/api/user';

export default {
    name: 'GoodFresh',
    data() {
        return {
            goodFreshList: [],//商品列表
            category_list: [],//分类列表
            order: 'comprehensive',//商品排序方式
            orderway: '',//排序方式
            cid: '',//分类ID
        }
    },
    created() {
        this.onCategory()
        this.onList()
    },
    methods: {
        /**收藏 */
        onCollect(id, i) {
            commodityCollect({ id: id }).then(res => {
                if (res.code == 1) {
                    if (this.goodFreshList[i].is_collect == 1) {
                        this.$message.success(this.$t('已取消'));
                        this.goodFreshList[i].is_collect = 0
                    } else {
                        this.$message.success('已收藏');
                        this.goodFreshList[i].is_collect = 1
                    }
                }
            })
        },
        /**选中分类 */
        handleCommand(e) {
            this.cid = e
            this.onList(e);
        },
        /**修改排序方式 */
        onSort(e) {
            if (e == 'comprehensive') {
                this.orderway = ''
            } else {
                if (this.orderway == 'desc') {
                    this.orderway = 'asc'
                } else {
                    this.orderway = 'desc'
                }
            }
            this.order = e
            this.onList()
        },
        /**分类列表 */
        onCategory() {
            categoryListings({ level: 2 }).then(res => {
                this.category_list = res.data
                // console.log(this.category_list);
                this.category_list.unshift({
                    id: 0,
                    image: "",
                    name: this.$t('全部'),
                    pid: 0
                })
            })
        },
        /**商品列表 */
        onList(id) {
            let data = {
                display_type: 'recommend',
                orderby: this.order,
                type_id: this.cid
            }
            if (this.orderway) {
                data.orderway = this.orderway
            }
            commodityList(data).then(res => {
                // console.log(res.data.data);
                this.goodFreshList = res.data.data
            })
        },
        /**商品详情 */
        gotoDetail(e) {
            this.$router.push({ name: 'ProductDetails', params: { id: e.id } })
        },
        getImagePath: function (name) {
            return require('@/assets/good-fresh/fresh-images/' + name + '.jpg');
        },
    }
};
</script>

<style scoped lang="scss">
#good-list {
    padding: 32px 0;
    box-sizing: border-box;
    border-top: 1px solid #EEE;
}

.good-list-tit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 8px 0;
    border-radius: 12px;
    flex-wrap: wrap;
    gap: 12px;

    .tit-left {
        font-size: 18px;
        color: #333333;

        @media (min-width: 768px) {
            font-size: 28px;
        }
    }

    .tit-right {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        .tit-right-project {
            margin-right: 0;
			padding: 5px 11px;
			border: 1px solid #EEEEEE;
			border-radius: 4px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;
                display: block;
                margin-left: 8px;
            }
        }

		.tit-right-project-active {
			border-color: #000000;
			color: #000000;
		}

		.category-filter-button {
			height: 30px;
			padding: 5px 11px;
			font-size: 14px;
			line-height: 18px;
			color: #606266;
			border-color: #EEEEEE;
			border-radius: 4px;

			&.el-button.is-plain:hover,
			&.el-button.is-plain:focus {
				color: #000000;
				background: #FFFFFF;
				border-color: #000000;
			}
		}
    }
}


/**列表 */
.list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 20px;
    }

    @media (min-width: 1280px) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 24px;
    }

    .list-box {
        width: 100%;
        margin-right: 0;
        margin-top: 12px;
        position: relative;
        transition: all 0.3s ease;
        border-radius: 8px;
        padding: 8px;
        box-sizing: border-box;
        cursor: pointer;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);

        @media (min-width: 768px) {
            margin-top: 40px;
            padding: 12px;
        }

        &:hover {
            @media (hover: hover) {
                transform: translateY(-5px);

                .img-container {
                    overflow: hidden;
                    border-radius: 8px;
                }
            }
        }

        .img-container {
            width: 100%;
            // PC 与 H5 统一使用 3:4 图片容器比例，避免同一商品图展示比例不一致。
            aspect-ratio: 3 / 4;
            height: auto;
            border-radius: 8px;
            overflow: hidden;
            background: #F5F5F5;
        }

        .box-img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            // 保持商品图片完整显示，适配不同宽高比例的图片。
            object-fit: contain;
            transition: transform 0.3s ease;

            @media (max-width: 767px) {
                // H5 按比例铺满容器，避免商品图过小露出容器背景。
                display: block;
                object-fit: cover !important;
                object-position: center;
            }
        }

        .box-bottom {
            margin-top: 10px;

            @media (min-width: 768px) {
                margin-top: 16px;
            }

            .box-bottom-tit {
                width: 100%;
                line-height: 18px;
                height: 36px;
                font-size: 13px;

                @media (min-width: 768px) {
                    line-height: 20px;
                    height: 40px;
                    font-size: inherit;
                }
            }

            .box-bottom-box {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 8px;
                flex-wrap: wrap;
                gap: 6px;

                .box-bottom-box-l {
                    color: #85674B;
                    font-size: 13px;
                }

                .box-bottom-box-r {
                    display: flex;
                    align-items: center;

                    .box-bottom-box-rl {
                        margin-right: 12px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }

                    .box-bottom-box-rr {
                        background: #FFFFFF;
                        border: 1px solid #000000;
                        display: flex;
                        border-radius: 4px;

                        .box-bottom-box-rrl {
                            padding: 6px 8px;

                            @media (min-width: 768px) {
                                padding: 8px 16px;
                            }

                            img {
                                width: 16px;
                                height: 16px;
                                display: block;

                                @media (min-width: 768px) {
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }

                        .box-bottom-box-rrr {
                            padding: 6px 10px;
                            font-size: 12px;
                            background: #000000;
                            color: #FFFFFF;
                            cursor: pointer;

                            @media (min-width: 768px) {
                                padding: 8px 16px;
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }

        .list-box-tag {
            position: absolute;
            top: 12px;
            left: 12px;
            padding: 2px 8px;
            font-size: 12px;
            color: #000000;
            border: 1px solid #000000;
            border-radius: 6px;
            background-color: rgba(255, 255, 255, 0.5);
        }
    }

    .list-box:nth-child(4n) {
        margin-right: 0;
    }
}

.goods-item {
    width: 100%;
    height: 291px;
    margin-bottom: 40px;
    background: #fff;
}

.goods-img {
    width: 100%;
    height: 194px;
    border-radius: 8px 8px 0 0;
}

.content-box {
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.price {
    color: #FD3B00;
    font-size: 18px;
}

.crossedPrice {
    color: #999;
    font-size: 14px;
    text-decoration: line-through;
}

.salesVolume {
    color: #999;
    font-size: 14px;
}
</style>

<style lang="scss">
/* 精选商品分类下拉菜单样式 */
.featured-category-dropdown {
	.el-dropdown-menu__item {
		padding: 0 12px;
		font-size: 14px;
		line-height: 30px;

		&:not(.is-disabled):hover,
		&:not(.is-disabled):focus {
			color: #000000;
			background: #F8F8F8;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/choicenessList.vue